import { TableColumnKey } from "../types/Table";

const exportButtonOmitKeys = [
  TableColumnKey.ActualEnergy,
  TableColumnKey.ActualBandwidth,
  TableColumnKey.RequiredEnergy,
  TableColumnKey.RequiredBandwidth,
  "rawData",
];

export { exportButtonOmitKeys };
